import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {getAllFilterDefaults} from '../../fetch/filterDefaultsAPI';
import {Data, FilterDefaultsState} from '../../types/FilterDefaultType';
import {AppDispatch} from '../../store';

const initialState: FilterDefaultsState = {
    data: null,
    loading: false,
    error: null,
    fetched: false
};

const filterDefaultsSlice = createSlice({
    name: 'filterDefaults',
    initialState,
    reducers: {
        filterDefaultsRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        filterDefaultsSuccess: (state, action: PayloadAction<Data>) => {
            state.loading = false;
            state.data = action.payload;
            state.fetched = true;
        },
        filterDefaultsFailure: (state) => {
            state.loading = false;
            state.error = 'Failed to fetch filter defaults';
        },
        filterDefaultsCleared: (state) => {
            state.data = null;
        }
    }
});

export const {filterDefaultsRequest, filterDefaultsSuccess, filterDefaultsFailure, filterDefaultsCleared} = filterDefaultsSlice.actions;
export default filterDefaultsSlice.reducer;

export const fetchFilterDefaults = () => async (dispatch: AppDispatch) => {
    dispatch(filterDefaultsRequest());
    try {
        const filterDefaults: Data = await getAllFilterDefaults(dispatch);
        dispatch(filterDefaultsSuccess(filterDefaults));
    } catch (error) {
        console.error('Failed to fetch filter defaults', error);
        dispatch(filterDefaultsFailure());
        dispatch(filterDefaultsCleared());
    }
};

export const clearFilterDefaults = () => (dispatch: AppDispatch) => {
    dispatch(filterDefaultsCleared());
};

// Export individual action creators for backward compatibility if needed
export const fetchFilterDefaultsRequest = () => filterDefaultsRequest();
export const fetchFilterDefaultsSuccess = (filterDefaults: Data) => filterDefaultsSuccess(filterDefaults);
export const fetchFilterDefaultsFailure = () => filterDefaultsFailure();
